<template>
  <div class="index_wrapper">
    <div class="tab">
      <ul class="img_list">
        <li @click="goTrade">
          <img src="~assets/images/index/transaction.png" alt />
          <div class="text">交易机会</div>
        </li>
        <li @click="goAnswer">
          <img src="~assets/images/index/hall.png" alt />

          <div class="text">问答大厅</div>
        </li>
        <!-- <li @click="goTeach">
          <img src="~assets/images/index/teach.jpg" alt />

          <div class="text">教学视频</div>
        </li> -->
        <li @click="goQuestion">
          <img src="~assets/images/index/problem.png" alt />

          <div class="text">我的问题</div>
        </li>
      </ul>
    </div>
    <div class="hot_part">
      <div class="title">
        <div class="title_left">热门问答</div>
        <div class="title_right" @click="goAnswer">全部问答 ></div>
      </div>
      <answer-party
        :hotQuestion="hotData"
        :symbolMap="symbolMap"
      ></answer-party>
    </div>
    <div class="choice_part" style="display: none">
      <div class="title">精选问题</div>
      <question-party :chioceQuestionData="choiceData"></question-party>
    </div>
  </div>
</template>

<script>
import answerParty from "components/answerParty";
import questionParty from "components/questionParty";

import { mapState, mapActions } from "vuex";
import { getStore } from "assets/commonjs/storage";

export default {
  data() {
    return {
      symbolMap: {},
    };
  },
  components: {
    answerParty,
    questionParty,
  },
  mounted() {
    this.init();
  },

  computed: {
    ...mapState(["hotData", "choiceData"]),
  },
  methods: {
    ...mapActions(["getStrageData"]),
    init() {
      this.getAllSymbal();
    },
    goAnswer() {
      if (
        getStore("noneheader") == null ||
        getStore("noneheader") == "" ||
        getStore("noneheader") == undefined
      ) {
        this.$router.push("/questionAnswer");
      } else {
        this.$router.push({
          path: "/questionAnswer",
          query: { noneheader: 1 },
        });
      }
    },
    goQuestion() {
      const userInfo = getStore("userInfoAll");
      const noneheader = getStore("noneheader");

      if (!userInfo) {
        if (!noneheader) {
          this.$router.push("/login");
        } else {
          window.location.href = "intercept_login";
        }
      } else {
        this.$router.push("/myQuestion");
      }
    },
    goTrade() {
      this.$router.push("/tradeChance");
    },
    goTeach() {
      this.$router.push("/videoRoom");
      this.showList = false;
    },
    getAllSymbal() {
      this.$api.strageList.getProductData().then((res) => {
        if (res.data.code == 0 && res.data.msg == "成功") {
          for (var i in res.data.data) {
            this.symbolMap[res.data.data[i].symbol] = res.data.data[i];
          }
        }
        this.getStrageData();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.index_wrapper {
  background: #f0f1f5;
  .tab {
    background: #fff;
    margin-bottom: 0.1rem;
    padding: 1rem 0 0.4rem 0;
  }
}

.img_list {
  @include fj();
  padding: 0 0.72rem;

  li {
    font-size: 0;
    img {
      @include wh(1.06rem, 1.06rem);
    }
    .text {
      @include sc(0.28rem, #333);
      margin-top: 0.2rem;
    }
  }
}
.hot_part {
  padding: 0.4rem 0.3rem 0.6rem;
  background: #fff;
  margin-bottom: 0.1rem;
  .title {
    @include fj();
    padding-bottom: 0.3rem;
    .title_left {
      @include sc(0.32rem, #333);
      font-weight: bold;
      position: relative;
      &:before {
        content: "";
        width: 0.06rem;
        height: 0.3rem;
        background: #0a95ff;
        position: absolute;
        left: -0.1rem;
        top: 0.05rem;
      }
    }
    .title_right {
      @include sc(0.24rem, #666);
      font-weight: bold;
    }
  }
}
.choice_part {
  padding: 0.4rem 0.3rem;
  background: #fff;
  .title {
    @include sc(0.32rem, #333);
    font-weight: bold;
    position: relative;
    &:before {
      content: "";
      width: 0.06rem;
      height: 0.3rem;
      background: #0a95ff;
      position: absolute;
      left: -0.1rem;
      top: 0.05rem;
    }
  }
}
</style>
